import React from "react";
import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";

export default function StarIconOpen(props) {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path d="M7.31563 13.83L9.98229 12.2467L12.6698 13.83L11.9615 10.83L14.274 8.85087L11.2115 8.58004L9.98229 5.72587L8.75313 8.58004L5.69062 8.85087L8.02396 10.83L7.31563 13.83ZM5.66983 16.0688L6.82206 11.2403L3 7.99192L8.01277 7.55604L9.98229 3L11.9518 7.57688L16.9646 7.99192L13.1425 11.2403L14.2947 16.0688L9.98229 13.5079L5.66983 16.0688Z" fill={props.color}/>
    </SvgIcon>
  );
}

StarIconOpen.propTypes = {
  color: PropTypes.string
};